export enum ProductTypeEnum {
	NONE = 0,
	PLAN = 1,
	ADDON = 2,
	BOOSTER = 3,
	DELIVERY = 4,
}

export const mapStringProductType: {
	[key: string]: ProductTypeEnum;
} = {
	PLAN: ProductTypeEnum.PLAN,
	ADDON: ProductTypeEnum.ADDON,
	BOOSTER: ProductTypeEnum.BOOSTER,
	STANDARD_DELIVERY: ProductTypeEnum.DELIVERY,
	EXPRESS_DELIVERY: ProductTypeEnum.DELIVERY,
	REGISTERED_DELIVERY: ProductTypeEnum.DELIVERY,
};
